var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { apiUrls } from "../../../example1/login/api_test/configuration";
import { convertUnit, fetchGzippedFileWithBlob } from "../../common";
export default function requestNcodeGzip_example(sobp, mediaSize, gzipped = true) {
    return __awaiter(this, void 0, void 0, function* () {
        return yield requestNcodeImage_UserCredential_example(sobp, mediaSize);
    });
}
const ncode_padding_mm = 20;
function requestNcodeImage_UserCredential_example(sobp, mediaSize, gzipped = true) {
    return __awaiter(this, void 0, void 0, function* () {
        const width = convertUnit(mediaSize.unit, mediaSize.width, "mm") + ncode_padding_mm;
        const height = convertUnit(mediaSize.unit, mediaSize.height, "mm") + ncode_padding_mm;
        const ret = {
            ok: false,
            status: -1,
            gzippedBlob: undefined,
            url: undefined,
            ncodeImageText: undefined,
        };
        const access_token = localStorage.getItem("idToken");
        // kitty, 2021/07/30
        const { section, owner, book, page } = sobp;
        let url = `${apiUrls.REQUEST_NCODE_IMAGE_USER_CREDENTIAL}`;
        url = url + `?section=${section}`;
        url = url + `&owner=${owner}`;
        url = url + `&book=${book}`;
        url = url + `&page=${page}`;
        if (width !== undefined)
            url = url + `&width=${Math.max(Math.round(width + 1), Math.round(height + 1))}`;
        if (height !== undefined)
            url = url + `&height=${Math.max(Math.round(width + 1), Math.round(height + 1))}`;
        const options = {
            method: 'GET',
            headers: {
                // 'Accept': 'application/json',
                // 'Content-Type': 'application/x-www-form-urlencoded',
                'Accept-Encoding': 'application/gzip',
                'Authorization': `bearer ${access_token}`,
                // 'Authorization': 'bHJ2b3doNHV4czg5aGw2ZXR6NGd6bjRrZTZubHY2am1ALm5lb2xhYi5uZXQ6Slhla25KTnh0RXJoVThDQk9mUnN6QlBaV3NMdzkweXc=',
            },
        };
        try {
            const { ncodeImageText, blob, ok, status } = yield fetchGzippedFileWithBlob(url, options);
            // const res = await fetch(url, options);
            if (ok) {
                ret.ok = true;
                ret.status = status;
                ret.gzippedBlob = yield blob;
                ret.ncodeImageText = ncodeImageText;
                // ret.url = url;
                const urlCreator = window.URL || window.webkitURL;
                const ncodedUrl = urlCreator.createObjectURL(ret.gzippedBlob);
                ret.url = ncodedUrl;
            }
            else {
                ret.status = 400;
            }
        }
        catch (e) {
            ret.status = 400;
        }
        return ret;
    });
}
//# sourceMappingURL=requestNcodeImage_example.js.map